import * as z from "zod/v4";

export const checkOrdersReturnability = {
  name: "checkOrdersReturnability" as const,
  input: z.object({ orderIds: z.array(z.string()) }),
  output: z.object({ returnability: z.record(z.string(), z.boolean()) }),
};
